import ReviewsSlider from "../../../components/reviews-slider";
import VideoModal from "../../../components/base/video-modal";
import Api from "../../../lib/api";

export default class PageModule {
	constructor() {
		this.initAboutSchoolVideo();
		this.initReviewsSlider();
		this.initStartSoon();
	}

	initAboutSchoolVideo() {
		const videoModal = new VideoModal({
			id: 'about-school'
		});
	}

	initReviewsSlider() {
		const reviewsSlider = new ReviewsSlider();
	}

	initStartSoon() {
		const $container = document.getElementById('startSoonContainer');

		if (!$container) {
			return;
		}

		Api.get(Api.apiSiteUrl + '/feed/courses-start-soon')
			.then(res => {
				const data = res && res.trim();

				if (!data) {
					return;
				}

				$container.innerHTML = data;
			});
	}
}